import webLogo from './TestLogo.svg'
import doctor_img from './doctor_img.png'
const IMAGES={
    webLogo:webLogo,
    doctor_img:doctor_img
}
export default IMAGES